/**
 * Client Supabase côté navigateur — RLS activée.
 * Le service role key NE DOIT JAMAIS être exposé ici.
 */

import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // eslint-disable-next-line no-console
  console.error("⚠️ VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY manquant");
}

export const supabase = createClient(url, anonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    storage: window.localStorage,
    storageKey: "kollectivia-auth",
    detectSessionInUrl: true,
  },
});
